// Overdue invoices: payable through the due date, overdue from the next calendar day
// (the same rule the server uses for reminders and the payments page).
const DAY_MS = 86400000;
const dayNumber = (value) => {
  const d = new Date(value);
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / DAY_MS;
};

export const OVERDUE_COLOR = '#C2410C';

// Whole days past the due date for an unpaid invoice; 0 when not overdue
export const daysOverdue = (invoice, now = new Date()) => {
  if (!invoice || !['pending', 'failed'].includes(invoice.status) || !invoice.dueDate) return 0;
  return Math.max(0, dayNumber(now) - dayNumber(invoice.dueDate));
};

// Days until the due date for an unpaid invoice (0 = due today), or null
export const daysUntilDue = (invoice, now = new Date()) => {
  if (!invoice || !['pending', 'failed'].includes(invoice.status) || !invoice.dueDate) return null;
  return dayNumber(invoice.dueDate) - dayNumber(now);
};

export const overdueLabel = (days) => `Overdue by ${days} ${days === 1 ? 'day' : 'days'}`;
